import React from "react";
import { Box } from "@material-ui/core";
import { useSelector } from "react-redux";
import numberFormatter from "utils/numberFormatter";
import KPIComparator from "components/visuals/KPIComparator";

import { useAppSelector } from "store";
import { selectStore, selectComparator } from "modules/customer/insights/portfolio/portfolioSlice";
import { selectors } from "modules/customer/insights/portfolio/areaHealth/marketCategorySpend";

const SpendPerHeadCatchmentArea = () => {
    const selectedStore = useAppSelector(selectStore);
    const selectedComparator = useAppSelector(selectComparator);
    const spendPerHeadCatchmentArea = useSelector(state => selectors.spendPerHeadCatchmentArea(state));
    const { loading, error, value, percentageDifference } = spendPerHeadCatchmentArea;
    const valueFormatted = numberFormatter.toGBP(value, 1);
    const label = `${selectedStore.name} Median Spend per Head Output Area with selected categories vs ${selectedComparator.name}`;

    return (
        <Box width="100%" height="100%" data-cy="spend-per-head-catchment-area">
            <KPIComparator loading={loading} error={error} label={label} value={valueFormatted} percentage={percentageDifference} />
        </Box>
    );
};

export default SpendPerHeadCatchmentArea;
